var React = require('react');

function Place (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.888 0c4.074 0 7.388 3.314 7.388 7.388 0 1.342-.6 2.784-.626 2.845a11.865 11.865 0 01-.854 1.597L8.73 19.505c-.207.315-.514.495-.842.495-.328 0-.634-.18-.842-.495L1.981 11.83c-.277-.42-.66-1.136-.854-1.597C1.1 10.172.5 8.729.5 7.388.5 3.314 3.814 0 7.888 0zm0 .87A6.526 6.526 0 001.37 7.387c0 1.161.552 2.489.56 2.507.172.413.53 1.08.777 1.456l5.066 7.676c.1.152.132.152.232 0l5.066-7.676c.248-.376.605-1.042.779-1.456.005-.013.558-1.344.558-2.507A6.526 6.526 0 007.888.87zm0 2.607A3.916 3.916 0 0111.8 7.39a3.916 3.916 0 01-3.91 3.91 3.916 3.916 0 01-3.912-3.91 3.916 3.916 0 013.911-3.912zm0 .87a3.046 3.046 0 00-3.042 3.042 3.046 3.046 0 003.042 3.042 3.046 3.046 0 003.042-3.042 3.046 3.046 0 00-3.042-3.043z"}));
}

Place.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Place;

Place.default = Place;
